import { call, put, takeEvery } from "redux-saga/effects";
import authenService from "services/authenService";
import { AUTH_TOKEN } from "store/auth/login/actionTypes";
import { RETRY_ACTION, TOKEN_REFRESH } from "./actionTypes";
import { retryAction } from "./actions";

function* retryOriginalAction({ actionTypeRetry, payload }) {
  yield put({ type: actionTypeRetry, ...payload });
}

function* tokenRefresh({ actionTypeRetry, payload }) {
  // TODO:
  const authToken = localStorage.getItem(AUTH_TOKEN);
  let response = null;
  // Generate new token base on refreshToken
  if (!authToken) {
    response = yield call(authenService.refreshToken);
    if (response) {
      localStorage.setItem(AUTH_TOKEN, response?.accessToken);
    }
  }
  // Check if need retry action
  if (actionTypeRetry) {
    yield put(retryAction(actionTypeRetry, payload));
  }
  // const authToken = localStorage.getItem(REFRESH_TOKEN);
  // if (authToken) {
  //   localStorage.setItem(AUTH_TOKEN, authToken);
  // }
  // if (actionTypeRetry) {
  //   yield put(retryAction(actionTypeRetry, payload));
  // }
}

// Watcher saga to listen for the retry action and token refresh success
function* retrySaga() {
  yield takeEvery(RETRY_ACTION, retryOriginalAction);
  yield takeEvery(TOKEN_REFRESH, tokenRefresh);
}

export default retrySaga;
